(function () {
  'use strict';
  function populate() {
    var params = new URLSearchParams(window.location.search);
    document.querySelectorAll('[data-ac-enquiry]').forEach(function (container) {
      var form = container.querySelector('form');
      var status = container.querySelector('[data-ac-submit-status]');
      if (form && status && !form.dataset.acFeedbackBound) {
        form.dataset.acFeedbackBound = 'true';
        var timer = null;
        function resetFeedback() {
          window.clearTimeout(timer);
          timer = null;
          status.textContent = '';
        }
        function watchSubmission() {
          if (timer !== null || !form.checkValidity()) return;
          status.textContent = status.dataset.acPending;
          timer = window.setTimeout(function () {
            timer = null;
            status.textContent = status.dataset.acDelayed;
          }, 20000);
        }
        form.addEventListener('submit', watchSubmission, true);
        form.addEventListener('click', function (event) {
          var button = event.target.closest('button[type="submit"], input[type="submit"]');
          if (button && button.form === form) watchSubmission();
        }, true);
        window.addEventListener('pagehide', resetFeedback);
        window.addEventListener('pageshow', function (event) {
          if (event.persisted) resetFeedback();
        });
      }
      var field = container.querySelector('[data-ac-rug-reference]');
      var topic = container.querySelector('[data-ac-enquiry-topic]');
      var title = (params.get('rug') || '').replace(/[\u0000-\u001f\u007f]/g, '').trim().slice(0,200);
      var path = params.get('product_path') || '';
      var productURL = '';
      if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9-]+$/i.test(path) && path.length <= 400) {
        try {
          var shop = new URL(container.dataset.acShopUrl);
          if (shop.protocol === 'https:') productURL = new URL(path, shop.origin).href;
        } catch (error) {}
      }
      if (field && !field.value.trim() && productURL) {
        field.value = title ? title + ' — ' + productURL : productURL;
      }
      var requestedTopic = params.get('topic');
      if (topic && ['choosing', 'custom', 'order', 'trade'].indexOf(requestedTopic) !== -1) {
        topic.value = requestedTopic;
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', populate, {once: true});
  else populate();
})();
